<div class="formModal">
  <div class="modal-header">
    <h5 class="modal-title" id="formModalLabel">
      <i class="fas fa-user-edit me-2"></i>
      Edit Profile
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="onCancel()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">
      <!-- Form -->
      <form [formGroup]="userProfileForm" (ngSubmit)="onSubmit()">

        <!-- Section 1: Personal Details -->
        <div class="section-card">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-user me-2"></i>
              Personal Details
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="displayName" class="form-label">Display Name</label>
                  <input type="text" id="displayName" class="form-control" formControlName="displayName"
                    placeholder="Enter display name">
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="email" class="form-label">Email</label>
                  <input type="email" id="email" class="form-control" formControlName="email"
                    placeholder="Email address" readonly>
                  <small class="form-text text-muted">Email cannot be changed</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="firstName" class="form-label">First Name<span class="text-danger">*</span></label>
                  <input type="text" id="firstName" class="form-control" formControlName="firstName"
                    [class.is-invalid]="isFieldInvalid('firstName')" placeholder="Enter first name">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('firstName')">
                    {{ getFieldError('firstName') }}
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="middleName" class="form-label">Middle Name</label>
                  <input type="text" id="middleName" class="form-control" formControlName="middleName"
                    placeholder="Enter middle name">
                </div>
              </div>
              <div class="col-md-4">
                <div class="mb-3">
                  <label for="lastName" class="form-label">Last Name<span class="text-danger">*</span></label>
                  <input type="text" id="lastName" class="form-control" formControlName="lastName"
                    [class.is-invalid]="isFieldInvalid('lastName')" placeholder="Enter last name">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('lastName')">
                    {{ getFieldError('lastName') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="phone" class="form-label">Phone Number<span class="text-danger">*</span></label>
                  <div class="input-group">
                    <select class="form-select flex-grow-0" formControlName="phoneCountryCode"
                      aria-label="Country code" style="width: 92px; padding-right: 1.75rem;">
                      <option *ngFor="let code of countryCodes" [value]="code">+{{ code }}</option>
                    </select>
                    <input type="tel" id="phone" class="form-control" formControlName="phone" maxlength="10"
                      [class.is-invalid]="isFieldInvalid('phone')" placeholder="Enter phone number">
                  </div>
                  <div class="text-danger small mt-1" *ngIf="isFieldInvalid('phone')">
                    {{ getFieldError('phone') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="temperatureUnit" class="form-label">Temperature Unit<span
                      class="text-danger">*</span></label>
                  <select id="temperatureUnit" class="form-select form-select-custom" formControlName="temperatureUnit"
                    [class.is-invalid]="isFieldInvalid('temperatureUnit')">
                    <option value="Celsius">Celsius</option>
                    <option value="Fahrenheit">Fahrenheit</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('temperatureUnit')">
                    {{ getFieldError('temperatureUnit') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label for="timezoneId" class="form-label">Timezone <span class="text-danger">*</span></label>
                  <select id="timezoneId" class="form-select form-select-custom" formControlName="timezoneId"
                    (change)="onTimezoneChange()" [class.is-invalid]="isFieldInvalid('timezoneId')">
                    <option value="" selected>Select Timezone</option>
                    <option *ngFor="let timezone of timeZones" [value]="timezone.id">{{ timezone.utcName }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('timezoneId')">
                    {{ getFieldError('timezoneId') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section 2: Address Details -->
        <div class="section-card">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-map-marker-alt me-2"></i>
              Address Details
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="address1" class="form-label">Address1<span class="text-danger">*</span></label>
                  <input type="text" id="address1" class="form-control" formControlName="address1"
                    [class.is-invalid]="isFieldInvalid('address1')" placeholder="Enter address1">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('address1')">
                    {{ getFieldError('address1') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="address2" class="form-label">Address2</label>
                  <input type="text" id="address2" class="form-control" formControlName="address2"
                    placeholder="Enter address2">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="city" class="form-label">City<span class="text-danger">*</span></label>
                  <input type="text" id="city" class="form-control" formControlName="city"
                    [class.is-invalid]="isFieldInvalid('city')" placeholder="Enter city">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('city')">
                    {{ getFieldError('city') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="zipcode" class="form-label">Zipcode<span class="text-danger">*</span></label>
                  <input type="text" id="zipcode" class="form-control" formControlName="zipcode"
                    [class.is-invalid]="isFieldInvalid('zipcode')" placeholder="Enter zipcode">
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('zipcode')">
                    {{ getFieldError('zipcode') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="countryId" class="form-label">Country<span class="text-danger">*</span></label>
                  <select id="countryId" class="form-select form-select-custom" formControlName="countryId"
                    (change)="onCountryChange()" [class.is-invalid]="isFieldInvalid('countryId')">
                    <option value=null selected>Select Country</option>
                    <option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('countryId')">
                    {{ getFieldError('countryId') }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="stateId" class="form-label">State</label>
                  <select id="stateId" class="form-select form-select-custom" formControlName="stateId"
                    [class.is-invalid]="isFieldInvalid('stateId')">
                    <option value=null selected>Select State</option>
                    <option *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="isFieldInvalid('stateId')">
                    {{ getFieldError('stateId') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section 3: Profile Picture -->
        <div class="section-card">
          <div class="section-header">
            <h6 class="section-title">
              <i class="fas fa-camera me-2"></i>
              Profile Picture
            </h6>
          </div>
          <div class="section-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="profilePictureFile" class="form-label">Upload Profile Picture</label>
                  <input type="file" id="profilePictureFile" class="form-control" accept="image/*"
                    (change)="onFileSelect($event)">
                  <small class="form-text text-muted">Supported formats: JPG, PNG, GIF
                    (Max: 5MB)</small>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Current Picture</label>
                  <div class="profile-picture-preview">
                    <img [src]="profilePicturePreview" alt="Profile Picture" class="img-thumbnail"
                      style="max-width: 150px; max-height: 150px;">
                    <div class="mt-2" *ngIf="profilePictureFile || userProfileForm.get('profilePicture')?.value">
                      <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeProfilePicture()">
                        <i class="fas fa-trash me-1"></i>Remove Picture
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary ms-2" (click)="onCancel()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary ms-2" (click)="onSubmit()">
      Update
    </button>
  </div>
</div>